import React from 'react';
import PlannedOrderModal from '../plannedOrderModal';

const ModalContainer = () => (
  <>
    <PlannedOrderModal />
  </>
);

export default ModalContainer;
